
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Component, Inject, ElementRef, ViewEncapsulation } from '@angular/core';
import { DialogComponentContent } from '@toro/common/shared/models/dialogs/DialogComponentContent';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IUserAcceptCampaign } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/user-accept-campaign';
import { FilesAction } from '@toro/common/shared/state-management/files/files.actions';

@Component({
    selector: 'user-accept-campaign-dialog',
    templateUrl: './user-accept-campaign-dialog.component.html',
    styleUrls: ['./user-accept-campaign-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UserAcceptCampaignComponent extends DialogComponentContent {

    public termsForm: FormGroup;
    public popoverLinkFuturos: string = `<div>
            <div class='pop-title'>Futuros</div>
            <div class='pop-content'>
                Futuros ou Contratos Futuros é a negociação do preço futuro de um ativo. Ele pode ser tanto um objeto (Milho, Café, Boi Gordo),
                uma moeda (como o dólar), um Índice (Bovespa, Índice S&P 500) ou mesmo uma taxa de juros.
            </div>
        </div>`;
    public modalInfo: IUserAcceptCampaign = {
        description: '',
        title: '',
        agreementFile: ''
    }

    public linkDownload: string = ''

    constructor(
        @Inject(MAT_DIALOG_DATA) private data,
        public elementRef: ElementRef,
        private dialogReference: MatDialogRef<UserAcceptCampaignComponent>,
        private formBuilder: FormBuilder,
        private store: Store<AppState>
    ) {     
        super(elementRef, '.modal-terms'); 
        
        this.modalInfo = data ? data : this.modalInfo; 

        this.termsForm = this.formBuilder.group({
            agree: ['', Validators.required]
        });
    }

    public download() {
        this.store.dispatch(
            {
                type: FilesAction.getFullFile,
                payload: {
                    id: this.modalInfo.agreementFile,
                    name: this.modalInfo.title
                }
            }
        );
    }

    /** Encerra o componente informando se há confirmação para realizar o 
     * investimento
     * @param confirm confirmação para realizar ou não do investimento.
     */
    dispose(confirm: boolean = false) {
        super.close(this.dialogReference, confirm);
    }

    formSubmitHandler(event: Event) {
        event.preventDefault();
        this.dispose(this.termsForm.controls.agree.value);
    }
}
